import {selector} from "./selector";

function showFormErrors(errors) {
    for (let prop in errors) {
        if (prop === 'order_number') $(selector.errorMessage).html(errors[prop]); else $('#' + prop).addClass('is-invalid').next().html(errors[prop]).show();
    }
}

const submitForm = (e) => {
    e.preventDefault();

    const $form = $(e.target);

    let formData = $form.serialize();

    $(selector.invalidFeedback).hide();
    $(selector.isInvalid).removeClass('is-invalid');
    $(selector.preloader).show();

    setTimeout(function () {
        $.ajax({
            async: true,
            url: '/tag-porucivanje-process-form',
            method: 'POST',
            dataType: 'json',
            data: formData,
            success: function (response) {
                if (response) {
                    $(selector.tagSerialNumber).prop('disabled', true);
                    $(selector.tagVerificationCode).prop('disabled', true);
                    $(selector.phoneNumber).prop('disabled', true);
                    $(selector.signature).val(response.signature);

                    $(document).off('submit', selector.checkoutForm);
                    $form.submit();
                } else {
                    $(selector.preloader).hide();
                    $(selector.errorMessage).show();
                    showFormErrors(response.errors);
                }
            },
            error: function (response) {
                $(selector.preloader).hide();
                $(selector.errorMessage).show();
                const r = $.parseJSON(response.responseText);
                showFormErrors(r.errors);
            }
        });
    }, 750);
}

// Serijski broj koji je popunila provera tablice - pamti se da bi mogao da se
// ocisti kad korisnik izmeni tablicu, a da se ne obrise rucni unos korisnika.
let autofilledSerialNumber = null;

function clearAutofilledSerialNumber() {
    const $serialNumber = $(selector.serialNumber);

    if (autofilledSerialNumber !== null && $serialNumber.val() === autofilledSerialNumber) {
        $serialNumber.val('');
    }

    autofilledSerialNumber = null;
}

const verififyRegistrationPlate = (e) => {
    e.preventDefault();

    const registrationPlate = e.target.value.trim();

    if (registrationPlate === '') {
        clearAutofilledSerialNumber();
        return;
    }

    $.ajax({
        type: 'POST',
        data: {'registration_plate': registrationPlate},
        url: '/verify-registration-plate',
        success: function (response) {
            if (response.status === 'ok') {
                autofilledSerialNumber = response.serialNumber;
                $(selector.serialNumber).val(response.serialNumber);
                return;
            }

            clearAutofilledSerialNumber();
        }
    });
}

const toggleCustomerType = function (e) {
    let customerType = parseInt($(e.target).val());

    if (customerType === 1) {
        for (const key in selector.form.customer) $(selector.form.customer[key]).parent('.form-group').show();
        for (const key in selector.form.business) $(selector.form.business[key]).parent('.form-group').hide();
    } else if (customerType === 2) {
        for (const key in selector.form.customer) $(selector.form.customer[key]).parent('.form-group').hide();
        for (const key in selector.form.business) $(selector.form.business[key]).parent('.form-group').show();
    } else {
        console.error('Undefined customer type');
    }
}

export {submitForm, verififyRegistrationPlate, toggleCustomerType};